import styled from "styled-components";

export const AuthHeaderStyled = styled.div.withConfig({
    shouldForwardProp: (prop) => !['mobileApps'].includes(prop)
})`
    position: fixed;
    width: 100%;
    display: flex;
    top: 2.9%; 
    left: 50%;            
    height: ${({mobileApps}) => mobileApps && '90px'};
    transform: translate(-50%, -50%);
    background: ${({theme})=> theme === 'dark' ? '#0c1E28': '#fff'};
    padding: 0 1rem;
    justify-content: space-between;
    align-items: ${({mobileApps}) => mobileApps ? 'flex-end': 'center'};
    z-index: 20;
    overflow-y: hidden;
    .logo{
        display: flex;
        flex-flow: column wrap;
        align-items: center;
        justify-content: center;
    }
    .rightItems{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        font-size: 1rem;
    }
    .showOptions, .hideOptions {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer !important;
    }
    .showOptions svg, .hideOptions svg {
        color: ${({theme}) => theme === 'dark' ? '#fff' : '#0C1E28'};
        transition: color 0.25s ease-in-out;
    }
    .showOptions:hover svg, .hideOptions:hover svg {
        color: ${({theme}) => theme === 'dark' ? '#5fbec5' : '#3E8F93'};
    }
    @media only screen and (min-width: 992px) {
        height: 90px;
        padding-top: 10px;
    }

`;

export const AuthBoxStyled = styled.div`
    background: ${({ theme }) => theme === 'dark' ? '#0c1E28': '#fff'};
    div{
        color: ${({ theme }) => theme === 'dark' ? '#fff': '#0C1E28'};

    }
`